export default [
  {
    path: '/relatorios',
    name: 'Relatorios',
    component: () => import( /* webpackChunkName: "Relatorios" */ '../relatorios/Relatorios'),
  },
  {
    path: '/relatorios-estoque',
    name: 'RelatoriosEstoque',
    component: () => import( /* webpackChunkName: "RelatoriosEstoque" */ '../relatorios/RelatoriosEstoque'),
  },
  {
    path: '/relatorios-clientes',
    name: 'RelatoriosClientes',
    component: () => import( /* webpackChunkName: "RelatoriosClientes" */ '../relatorios/RelatoriosClientes'),
  },
  {
    path: '/relatorios-vendas',
    name: 'RelatoriosVendas',
    component: () => import( /* webpackChunkName: "RelatoriosVendas" */ '../relatorios/RelatoriosVendas'),
  }
]



// WEBPACK FOOTER //
// ./src/pages/relatorios/router.js